<p-autoComplete id="postcodes" [(ngModel)]="value" [suggestions]="tags" [multiple]="true"
  (completeMethod)="query=$event.query" (ngModelChange)="onChange($event)"></p-autoComplete>